<template>
  <div class="basic_wrap">
    
    <!-- ================= 顶部紫色头部 ================= -->
    <div class="header_bg">
      <!-- 返回箭头 -->
      <div class="back_btn" @click="$router.back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </div>
      
      <!-- 顶部标题 -->
      <div class="header_title">
        <div class="main_title">{{ $t('utils.kcode') }}</div>
        <div class="sub_title">{{ $t('utils.code1') }}</div>
      </div>

      <!-- 顶部中央大卡片 (礼物盒 + 说明) -->
      <div class="hero_card">
        <div class="gift_icon_box">
          <svg width="32" height="32" viewBox="0 0 512 512" fill="#fff"><path d="M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"/></svg>
        </div>
        <div class="hero_title">{{ $t('utils.code2') }}</div>
        <div class="hero_desc">{{ $t('utils.code3') }}</div>
      </div>
    </div>

    <!-- ================= 下方内容区 ================= -->
    <div class="main_content">
      
      <!-- 1. 输入框卡片 (深色底) -->
      <div class="input_card">
        <div class="input_label">{{ $t('utils.kcode') }}</div>
        <div class="input_wrap">
          <div class="input_icon">
            <svg width="14" height="14" viewBox="0 0 448 512" fill="#fff"><path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
          </div>
          <input 
            v-model="code"
            class="code_input"
            placeholder="XXXX-XXXX-XXXX"
            maxlength="32"
          >
        </div>
      </div>

      <!-- 2. 规则提示卡片 (浅灰色底) -->
      <div class="info_card">
        <div class="info_icon_box">!</div>
        <div class="info_texts">
          <p class="info_title">{{ $t('utils.code4') }}</p>
          <p class="info_item">• {{ $t('utils.code5') }}</p>
          <p class="info_item">• {{ $t('utils.code6') }}</p>
          <p class="info_item">• {{ $t('utils.code9') }}</p>
        </div>
      </div>

      <!-- 3. 底部操作按钮 -->
      <div class="action_btns">
        <div class="cancel_btn" @click="$router.back()">
          {{ $t('utils.code7') }}
        </div>
        <div class="submit_btn" @click="playcode()">
          {{ $t('utils.code8') }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Clipboard from "v-clipboard";
import { Icon, List, Empty, Popup } from "vant";

Vue.use(Icon).use(Clipboard).use(List).use(Empty).use(Popup);

export default {
  name: "Kode",
  data() {
    return {
      user_info: [],
      report: {
        "direct_count": 0,
        "indirect_count": 0,
        "income": 0,
        "income_to": 0,
        "income_ye": 0,
        "add_count": 0,
        "add_count_to": 0,
        "add_count_ye": 0
      },
      show_share: false,
      actives:1,
      empty: false,
      loading: false,
      finished: false,
      code:""
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('kode');
  },
  mounted() {
    this.start();
  },
  methods: {
    copy() {
      this.$toast(this.$t('recharge.copySuccess'));
    },
    playcode(){
      if(this.code.length < 1){
        this.$toast(this.$t('utils.code10'));
        return false;
      } else {
        Fetch('/user/playcode', {
          code: this.code
        }).then(r => {
          if(r.code == '218'){
            this.$toast(this.$t(r.info));
            return false;
          } else {
            this.$toast(this.$t('utils.code11') + 'Rp' + r.data.num);
            return false;
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  min-height: 100vh;
  padding-bottom: 30px;
  background-color: #f4f7fc;
  /* 浅蓝网格背景 */
  background-image: linear-gradient(#dce5ef 1px, transparent 1px), linear-gradient(90deg, #dce5ef 1px, transparent 1px);
  background-size: 20px 20px;
}

/* ================= 顶部紫色头部 ================= */
.header_bg {
  width: 100%;
  height: 250px;
  background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 80%);
  padding: 16px 20px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0 0 24px 24px;

  .back_btn {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .header_title {
    margin-top: 8px;
    text-align: center;
    .main_title { font-size: 18px; font-weight: 700; color: #fff; }
    .sub_title { font-size: 12px; color: rgba(255,255,255,0.8); margin-top: 4px; }
  }

  .hero_card {
    width: 100%;
    max-width: 320px;
    height: 140px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;

    .gift_icon_box {
      width: 48px;
      height: 48px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
    }

    .hero_title {
      font-size: 15px; font-weight: 600; color: #fff; margin-bottom: 4px;
    }
    .hero_desc {
      font-size: 12px; color: rgba(255,255,255,0.8);
    }
  }
}

/* ================= 下方内容区 ================= */
.main_content {
  padding: 0 16px;
}

/* 1. 输入框卡片 */
.input_card {
  background: #1e293b;
  border-radius: 16px;
  padding: 16px;
  margin-top: -10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);

  .input_label {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .input_wrap {
    display: flex;
    align-items: center;
    background: #0f172a;
    border: 1px solid #334155;
    border-radius: 12px;
    height: 48px;
    padding: 0 4px;

    .input_icon {
      width: 36px;
      height: 36px;
      background: #7c3aed;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 8px;
    }

    .code_input {
      flex: 1;
      height: 100%;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      font-size: 14px;
      letter-spacing: 1px;
      padding-right: 12px;
      &::placeholder {
        color: #475569;
      }
    }
  }
}

/* 2. 规则提示卡片 */
.info_card {
  background: #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  margin-top: 14px;
  display: flex;
  align-items: flex-start;
  gap: 12px;

  .info_icon_box {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #b45309;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .info_texts {
    flex: 1;
    .info_title {
      font-size: 13px;
      font-weight: 600;
      color: #1e293b;
      margin-bottom: 6px;
    }
    .info_item {
      font-size: 12px;
      color: #475569;
      line-height: 1.6;
    }
  }
}

/* 3. 底部操作按钮 */
.action_btns {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  height: 48px;

  .cancel_btn {
    flex: 1;
    background: #1e293b;
    color: #e2e8f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    &:active { opacity: 0.8; }
  }

  .submit_btn {
    flex: 1;
    background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%);
    color: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    &:active { opacity: 0.8; }
  }
}
</style>